import React from 'react';
import {
    Button,
    Chip,
    CircularProgress,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Toolbar,
    Tooltip,
    Typography,
    withStyles
} from "material-ui";
import {Companies} from "../../components/companies";
import {connect} from "react-redux";
import {Add, Delete, Edit, FilterList} from "material-ui-icons";
import {clearTasks, closeGetTasksFetch, getTasks, setEditTask} from "../../redux/actions/tasks";
import {TaskDialog} from "./dialog";
import {TaskDeleteDialog} from "./dialog/delete";
import {TaskFilterDrawer} from "./drawer/filter";
import {openTaskFilterDrawer} from "../../redux/actions/drawer";

const priorities = [
    '高優先', '通常', '低優先'
];

export class TaskComponent extends React.Component {

    state = {
        dialogOpen: false,
        dialogDeleteOpen: false,
    };

    componentDidMount = () => {
        document.title = '課題 | 三島事務所';
        this.props.initialize();

        if (!this.props.currentUser.is_admin) {
            this.props.getTasks(this.props.currentUser.company_id);
        }
    };

    /**
     * 顧客選択
     * @param company
     */
    onCompanySelect = (company) => {
        this.props.getTasks(company.id);
    };

    onTaskAdd = () => {
        this.props.setEditTask({});
        this.dialogOpen();
    };

    /**
     * タスク編集
     * @param task
     */
    onTaskEdit = (task) => {
        this.props.setEditTask(task);
        this.dialogOpen();
    };

    /**
     * ダイアログを開く
     */
    dialogOpen = () => {
        this.setState({dialogOpen: true});
    };

    /**
     * ダイアログを閉じる
     */
    dialogClose = () => {
        this.setState({dialogOpen: false});
        this.props.getTasks(this.props.activeCompanyId);
        setTimeout(() => {
            this.props.setEditTask({});
        }, 200);
    };

    /**
     * タスク詳細画面へ遷移
     */
    goTaskDetail = (task) => {
        this.props.history.push(`/task/${task.id}`);
    };

    onTaskDeleteEdit = (task) => {
        this.props.setEditTask(task);
        this.dialogDeleteOpen();
    };

    dialogDeleteOpen = () => {
        this.setState({dialogDeleteOpen: true});
    };

    dialogDeleteClose = () => {
        this.setState({dialogDeleteOpen: false});
        this.props.getTasks(this.props.activeCompanyId);
        setTimeout(() => {
            this.props.setEditTask({});
        }, 200);
    };

    onFilterDrawerClose = () => {
        this.props.getTasks(this.props.activeCompanyId);
    };

    render() {

        const {classes, currentUser, tasks, isGetTasksFetch, filter} = this.props;
        const {dialogOpen, dialogDeleteOpen} = this.state;

        return (
            <div className={classes.root}>

                {currentUser.is_admin ?
                    <Companies
                        onCompanySelect={this.onCompanySelect}/> : null}

                <Paper className={classes.mainContainer}>
                    {!isGetTasksFetch && tasks.length === 0 ? '課題が登録されていません' :
                        <div>
                            {isGetTasksFetch ? <CircularProgress/> :

                                <div>
                                    <Toolbar className={classes.toolbar}>
                                        <div className={classes.title}>
                                            <Typography variant="title">課題一覧</Typography>
                                        </div>
                                        <div className={classes.spacer}/>

                                        <div className={classes.actions}>
                                            <Tooltip title="フィルター">
                                                <IconButton onClick={this.props.openTaskFilterDrawer}>
                                                    <FilterList/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </Toolbar>

                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>優先度</TableCell>
                                                <TableCell>項目</TableCell>
                                                <TableCell>期日</TableCell>
                                                {currentUser.is_admin ?
                                                    <TableCell className={classes.actionCell}>アクション</TableCell> : null}

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {tasks.map(n => {

                                                if (!filter[n.status - 1]) {
                                                    return null;
                                                }

                                                return <TableRow key={n.id} hover>
                                                    <TableCell
                                                        className={classes.clickCell}
                                                        onClick={this.goTaskDetail.bind(this, n)}>
                                                        <Chip label={priorities[n.priority - 1]}
                                                              className={classes.chip}/>
                                                    </TableCell>
                                                    <TableCell
                                                        className={classes.clickCell}
                                                        onClick={this.goTaskDetail.bind(this, n)}>
                                                        {n.name}
                                                        {n.pic === undefined ? <span
                                                            className={classes.dangerMessage}>担当者が設定されていません</span> : ''}

                                                    </TableCell>
                                                    <TableCell
                                                        className={classes.clickCell}
                                                        onClick={this.goTaskDetail.bind(this, n)}>
                                                        {n.limited_at}</TableCell>
                                                    {currentUser.is_admin ?
                                                        <TableCell>
                                                            <IconButton
                                                                onClick={this.onTaskEdit.bind(this, n)}><Edit/></IconButton>
                                                            <IconButton
                                                                onClick={this.onTaskDeleteEdit.bind(this, n)}><Delete/></IconButton>
                                                        </TableCell>
                                                        : null}
                                                </TableRow>
                                            })}
                                        </TableBody>
                                    </Table>
                                </div>
                            }
                        </div>
                    }

                    <Button variant="fab"
                            color="primary"
                            onClick={this.onTaskAdd}
                            className={classes.fabButton}>
                        <Add/>
                    </Button>
                </Paper>

                <TaskDialog
                    handleClose={this.dialogClose}
                    open={dialogOpen}/>

                <TaskDeleteDialog
                    open={dialogDeleteOpen}
                    handleClose={this.dialogDeleteClose}/>

                <TaskFilterDrawer
                    handleClose={this.onFilterDrawerClose}/>

            </div>
        )
    }
}

const styles = theme => ({
    root: {
        display: 'flex',
        height: 'calc(100vh - 64px)',
        position: 'relative',
    },
    mainContainer: {
        paddingTop: 4,
        background: '#fbfbfb',
        zIndex: 1,
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'auto',
    },
    fabButton: {
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
    clickCell: {
        cursor: 'pointer'
    },
    actionCell: {
        width: 170,
    },
    chip: {
        margin: theme.spacing.unit,
    },
    dangerMessage: {
        display: 'block',
        color: '#F44336',
        fontSize: '.8em'
    },
    title: {
        flex: '0 0 auto',
    },
    spacer: {
        flex: '1 1 100%',
    },
});

TaskComponent = withStyles(styles)(TaskComponent);
TaskComponent = connect(
    (state) => {
        return {
            currentUser: state.users.currentUser,
            tasks: state.tasks.tasks,
            isGetTasksFetch: state.tasks.isGetTasksFetch,
            activeCompanyId: state.app.activeCompanyId,
            filter: state.filter.task.status,
        }
    },
    (dispatch) => {
        return {
            initialize: () => {
                dispatch(clearTasks());
            },
            getTasks: (companyId) => {
                dispatch(getTasks(companyId)).then(() => {
                    setTimeout(() => {
                        dispatch(closeGetTasksFetch());
                    }, 300);
                });
            },
            setEditTask: (task) => {
                dispatch(setEditTask(task));
            },
            openTaskFilterDrawer: () => {
                dispatch(openTaskFilterDrawer());
            },
        }
    }
)(TaskComponent);


// WEBPACK FOOTER //
// ./src/containers/task/index.js